import UTILSService from "../utils-service/utils.service";

export type MappedRow = Record<string, any>;
export type ValidatedRow = MappedRow & { emailError: boolean };

class IMPORTservice {
  /**
   * Validate a mapped dataset. Returns the annotated rows and a boolean
   * indicating if ANY row has an email error.
   */
  validationCheck(data: MappedRow[]): { rows: ValidatedRow[]; check: boolean } {
    const { rows, hasAnyError } = this.checkMappedData(data);
    return { rows, check: hasAnyError };
  }

  /**
   * Annotate each row with `emailError` (true when Email is missing/invalid).
   * Also returns whether any row had an error.
   */
  private checkMappedData(mappedData: MappedRow[]): {
    rows: ValidatedRow[];
    hasAnyError: boolean;
  } {
    let hasAnyError = false;
    const rows: ValidatedRow[] = (mappedData || []).map((item) => {
      const rawEmail = item?.Email ?? "";
      const emailStr = String(rawEmail).trim();
      const isInvalid =
        emailStr.length === 0 ? true : !UTILSService.EMAIL_REGEX.test(emailStr);

      if (!hasAnyError && isInvalid) hasAnyError = true;

      return { ...(item as MappedRow), emailError: isInvalid };
    });

    return { rows, hasAnyError };
  }

  /**
   * Return a NEW array with the item at `index` removed.
   * (No in-place mutation of the input array.)
   */
  skipRow<T = ValidatedRow>(data: T[], index: number): T[] {
    if (!Array.isArray(data) || index < 0 || index >= data.length) return data ?? [];
    return [...data.slice(0, index), ...data.slice(index + 1)];
  }

  /**
   * Return a NEW array with all rows that DO NOT have `emailError === true`.
   * (Caller provides the current validated array.)
   */
  skipAll<T extends { emailError?: boolean }>(validatedRows: T[]): T[] {
    if (!Array.isArray(validatedRows)) return [];
    return validatedRows.filter((r) => r?.emailError !== true);
  }
}

export default new IMPORTservice();
